{{#generate dimensionPropertiesList blockNamePrefix}}
  {{> (partial "harness/generate-interface-instances") harness=harness dimensionPropertiesList=dimensionPropertiesList.next blockNamePrefix=blockNamePrefix uvcInstances=uvcInstances}}
{{else}}
{{#each uvcInstances delimeter="\n"}}
{{> (partial "harness/interface-instance") context=../harness uvcInstance=.}}
{{/each}}
{{/generate}}
